<!--  -->
<template>
  <div>
    <el-form
      ref="ruleForm"
      :model="parameter"
      :rules="rules"
      label-width="130px"
      class="demo-ruleForm"
    >
      <p class="fenqu">
        活动信息
      </p>
      <el-form-item
        label="活动名称"
        prop="title"
      >
        <el-input
          v-model="parameter.title"
          v-model.trim="parameter.title"
          style="width:300px"
          @input="parameter.title = parameter.title.replace(reg, '')"
        />
        <div>仅后台展示</div>
      </el-form-item>
      <el-form-item
        label="活动标题"
        prop="copywriting"
      >
        <el-input
          v-model="parameter.copywriting"
          style="width:300px"
          placeholder="建议标题不超过12字符，超过了前端展示效果差"
        />
        <div>仅前台展示，且前端活动页面标题区活动标题配置<span style="color: red;">（活动金额慎用0.01元），若使用请注意付费卡点</span></div>
      </el-form-item>
      <el-form-item
        label="活动金额"
        prop="pid_1"
      >
        <!-- <el-radio-group
          v-model="parameter.pid_1"
          class="myRadioGroup"
        >
          <el-radio
            v-for="item in mys.options"
            :key="item.value"
            :label="item.value"
            style="width: 120px"
          >
            {{ item.description }}</el-radio>
        </el-radio-group> -->
        <el-select
          v-model="vipcount"
          placeholder="请选择会员类型"
          @change="vipchanger"
        >
          <el-option
            v-for="item in optionsdata"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <el-select
          v-model="parameter.pid_1"
          placeholder="请选择活动金额"
          style="margin-left:10px"
        >
          <el-option
            v-for="item in optionscountarr"
            :key="item.pid"
            :label="item.money"
            :value="item.pid"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="期限选择">
        <el-select
          v-model="time_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="time_type === 2"
        label="固定天数"
        prop="appoint_day"
      >
        <el-input
          v-model="parameter.appoint_day"
          style="width:300px"
          placeholder="请输入固定天数"
          type="number"
          :onkeyup="parameter.appoint_day = parameter.appoint_day.replace(/[^A-z0-9]/, '')"
        />
      </el-form-item>
      <el-form-item
        v-if="time_type === 1"
        label="活动时间"
        prop="date"
      >

        <el-date-picker
          v-model="parameter.date"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />

      </el-form-item>

      <el-form-item
        label="限购次数"
        prop="buy_times"
      >
        <el-radio-group v-model="parameter.buy_times">
          <el-radio :label="1">1次</el-radio>
          <el-radio :label="2">2次</el-radio>
          <el-radio :label="3">3次</el-radio>
          <el-radio :label="50">无限次</el-radio>
          <!-- <el-radio label="2次" />
          <el-radio label="3次" />
          <el-radio label="无限次" /> -->
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="活动弹窗"
        prop="has_popup"
      >
        <el-radio-group
          v-model="parameter.has_popup"
          @change="activepopup"
        >
          <el-radio label="开启" />
          <el-radio label="关闭" />
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="parameter.has_popup == '开启'"
        label="展示位置"
        prop="popup_display_area"
      >
        <el-checkbox-group v-model="parameter.popup_display_area">
          <el-checkbox
            v-for="item in themarr"
            :key="item.description"
            :label="item.value"
          >
            {{ item.description }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-if="parameter.has_popup == '开启'"
        label="弹窗接收用户"
        prop="popup_audience"
      >
        <el-radio-group v-model="parameter.popup_audience">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">已经充值用户</el-radio>
          <el-radio :label="2">未充值用户</el-radio>
          <!-- <el-radio label="2次" />
          <el-radio label="3次" />
          <el-radio label="无限次" /> -->
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="阅读页banner"
        prop="has_banner"
      >
        <el-radio-group
          v-model="parameter.has_banner"
          @change="bannerpopup"
        >
          <el-radio label="开启" />
          <el-radio label="关闭" />
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="parameter.has_banner == '开启'"
        label="banner接收用户"
        prop="banner_audience"
      >
        <el-radio-group v-model="parameter.banner_audience">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">已经充值用户</el-radio>
          <el-radio :label="2">未充值用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <p class="fenqu" />

      <el-form-item
        label="接受粉丝"
        prop="user_type"
      >
        <el-radio-group v-model="parameter.user_type">
          <el-radio :label="0">全量用户</el-radio>
        </el-radio-group>
        <p style="margin:0px; line-height: 1.7;">此处选择接受粉丝会与弹窗接收用户和Banner接收用户分别做交集（例如：弹窗接收用户是已经充值用户，阅读页Banner接收用户是未充值用户，此处选择全量用户，取交集，则弹窗是已经充值用户可见，阅读页Banner是未充值用户可见）</p>
      </el-form-item>

      <el-form-item
        label="活动模板"
        prop="activityid"
      >
        <el-input
          v-model="parameter.tpl_id"
          style="width:100px;margin-right:10px;display:none"
          disabled
        />
        <el-tag
          v-if="parameter.tpl_id"
          style="margin-right:10px"
        >{{ name }}</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="chooseactivitytem"
        >选择活动模板</el-button>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >立即创建</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="活动模板"
      :visible.sync="activitydialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <activitytemplate
        ref="activityview"
        :active_id="mys.active"
        @callbacktemp="callbacktemp"
      />
    </el-dialog>
  </div>
</template>

<script>
import activitytemplate from './activitytemplate1.vue'
import { acawraccountlist, readingservice } from '@/api/sourceMaterial.js'

export default {
  components: {
    activitytemplate
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.date[0] == this.parameter.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      themarr: [
        {
          value: 'index_page',
          description: '首页 '
        },
        {
          value: 'boy_page',
          description: '男生'
        },
        {
          value: 'girl_page',
          description: '女生'
        },
        {
          value: 'bookshelf_page',
          description: '书架'
        },
        {
          value: 'recent_read_page',
          description: '最近阅读页'
        },
        {
          value: 'home_page',
          description: '我的个人中心'
        },
        {
          value: 'read_page',
          description: '书籍阅读页'
        }
      ],
      activitydialogVisible: false,
      mys: {
        options: [],
        active: ''
      },
      name: '',
      parameter: {
        date: [],
        title: null, // 活动名称
        pid_1: '', // 活动金额
        pid_2: '',
        buy_times: null, // 限购次数
        stime: null, // 开始时间
        etime: null, // 结束时间
        copywriting: null, // 活动标题
        tpl_id: null, // 模版id
        has_popup: null, // 活动弹窗
        popup_audience: 0, // 弹窗接收用户
        popup_display_area: [], // 弹窗位置
        has_banner: null, // 阅读页banner
        banner_audience: null, // banner接收用户
        user_type: 0, // 接受粉丝
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        },
        {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      rules: {
        date: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        title: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        copywriting: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        tpl_id: [{ required: true, message: '请选择模版id', trigger: 'blur' }],
        has_popup: [{ required: true, message: '请选择活动弹窗', trigger: 'blur' }],
        popup_display_area: [{ type: 'array', required: true, message: '请至少选择一个展示位置', trigger: 'change' }],
        popup_audience: [{ required: true, message: '请选择弹窗接收用户', trigger: 'blur' }],
        banner_audience: [{ required: true, message: '请选择banner接收用户', trigger: 'blur' }],
        pid_1: [{ required: true, message: '请选择活动金额', trigger: 'blur' }],
        buy_times: [{ required: true, message: '请选择限购次数', trigger: 'blur' }],
        has_banner: [{ required: true, message: '请选择阅读页', trigger: 'blur' }]
      },
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      optionsdata: [],
      vipcount: null,
      optionscountarr: []
    }
  },
  created() {
    window.aa = this
    this.init_k()
  },
  mounted() {},
  methods: {
    datavalue(val) {
      console.log('val', val)
      this.parameter.stime = val[0]
      this.parameter.etime = val[1]
    },
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.parameter.stime
            par.end_time = this.parameter.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.parameter.appoint_day)
          }
          const obj = this.componentData()
          console.log(obj)
          await readingservice({
            platform_id: this.platformid,
            activity_type: 2,
            activity_info: obj,
            ...par
          })
          try {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          } catch (err) {
            this.$message({
              message: err,
              type: 'warning'
            })
          }
        } else {
          false
        }
      })
    },

    // 组件数据
    componentData() {
      // const buy_time = {
      //   '一次': 1,
      //   '两次': 2,
      //   '三次': 3,
      //   '无限': 50
      // }
      // const popup_audience = {
      //   '全部': 0,
      //   '已经充值用户': 1,
      //   '未充值用户': 2

      // }
      console.log('this.parameter.buy_time', this.parameter.buy_times)
      return {
        display: 'json',
        title: this.parameter.title,
        pid_1: this.parameter.pid_1,
        pid_2: '',
        // stime: +new Date(this.parameter.date[0]),
        // etime: +new Date(this.parameter.date[1]),
        // stime: this.parameter.stime,
        // etime: this.parameter.etime,
        // buy_times: buy_time[this.parameter.buy_times],
        buy_times: this.parameter.buy_times,
        copywriting: this.parameter.copywriting,
        tpl_id: Number(this.parameter.tpl_id),
        has_popup: this.parameter.has_popup === '开启' ? 1 : 0,
        // popup_audience: popup_audience[this.parameter.popup_audience],
        popup_audience: this.parameter.popup_audience,
        popup_display_area: this.parameter.popup_display_area.toString(),
        has_banner: this.parameter.has_banner === '开启' ? 1 : 0,
        banner_audience: this.parameter.banner_audience,
        user_type: 0
      }
    },

    chooseactivitytem() {
      this.activitydialogVisible = true
      this.$nextTick(() => {
        this.$refs.activityview.send(this.platformid, 1)
      })
    },

    callbacktemp(val, description) {
      this.activitydialogVisible = false
      this.parameter.tpl_id = val
      this.mys.active = val
      this.name = description
      console.log('val', val)
    },
    activepopup(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == '关闭') {
        this.parameter.popup_display_area = ['index_page', 'boy_page', 'girl_page', 'bookshelf_page', 'recent_read_page', 'home_page', 'read_page']
        this.parameter.popup_audience = 0
      } else {
        this.parameter.popup_display_area = []
      }
    },
    bannerpopup(val) {
      // eslint-disable-next-line eqeqeq
      if (val == '关闭') {
        this.parameter.banner_audience = 0
      } else {
        // this.parameter.popup_display_area = []
      }
    },
    async init_k() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 2
      })
      this.optionsdata = data.data.programme
      console.log('data', data.data.programme)
      // this.mys.options = data.data.programme
      // this.mys.active = data.data.theme && data.data.theme[0] ? data.data.theme[0].value : 0
      // this.parameter.tpl_id = data.data.theme && data.data.theme[0] ? data.data.theme[0].value : 0
      // console.log('data222', data)
      // this.name = data.data.theme && data.data.theme[0] ? data.data.theme[0].description : ''
    },
    vipchanger(val) {
      console.log('val', val)
      this.parameter.pid_1 = ''
      const index = this.optionsdata.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.key == val
      })
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log(index)
        this.optionscountarr = this.optionsdata[index].config
        console.log('找到id')
      } else {
        console.log('没找到id')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.fenqu {
  font-size: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 12px;
}

.myRadioGroup label {
  width: 120px;
  margin-bottom: 5px;
}
</style>
